import { APP_PERMISSIONS } from '@user-management/permissions';
import { PermissionRoute, type PermissionRouteData } from '@user-management/router';

export default function UserManagementHomePagePermissionRoute() {
  const routes: PermissionRouteData[] = [
    {
      path: '/user-management',
      requiredPermission: [APP_PERMISSIONS.SETTING.USER.VIEW],
    },
    {
      path: '/roles-and-permissions',
      requiredPermission: [APP_PERMISSIONS.SETTING.ROLE.VIEW],
    },
  ];
  return <PermissionRoute routes={routes} />;
}
